import Phaser from 'phaser';
import { GAME } from '../config';
import { loadBalance, applyBossBalance } from '../data/balance-loader';
import { BOSS_POOL } from '../entities/boss-pool';
import { TIER2_BOSS_POOL } from '../entities/boss-tier2-pool';
import { BOSS_TIER3_POOL } from '../entities/boss-tier3-pool';

export class LoadingScene extends Phaser.Scene {
  constructor() { super('LoadingScene'); }

  preload(): void {
    // Main asset loading should happen here (moved from BattleScene in a future refactor).
    // For now, scope is minimal: just show progress UI and transition.
  }

  create(): void {
    this.cameras.main.setBackgroundColor('#0a1929');

    this.add.text(GAME.width / 2, GAME.height / 2 - 40, '永恆要塞', {
      fontSize: '48px', color: '#00b3ff', fontFamily: 'serif',
    }).setOrigin(0.5);

    this.add.text(GAME.width / 2, GAME.height / 2 + 30, '載入中...', {
      fontSize: '18px', color: '#cfd8dc',
    }).setOrigin(0.5);

    const tips = ['遇到魔王試試凍結技能', '連續登入有禮物', '錯題本可重練', '設定可調音量'];
    const tip = tips[Math.floor(Math.random() * tips.length)];
    this.add.text(GAME.width / 2, GAME.height - 40, `💡 ${tip}`, {
      fontSize: '14px', color: '#80cbc4',
    }).setOrigin(0.5);

    // Kick off balance fetch in background; apply boss patches when done.
    // Cache ensures HorizontalBattleScene.create() gets the same config instantly.
    loadBalance().then((config) => {
      const allDefs = [...BOSS_POOL, ...TIER2_BOSS_POOL, ...BOSS_TIER3_POOL];
      applyBossBalance(config, allDefs);
    }).catch((err) => {
      console.warn('[LoadingScene] balance load failed, using defaults:', err);
    });

    this.time.delayedCall(800, () => this.scene.start('TitleScene'));
  }
}
